export const IS_LOADING = 'app/IS_LOADING';
export const IS_ERROR = 'app/IS_ERROR';
